<dx-validation-group #forgotPasswordValidationGroup>
    <dx-responsive-box>
        <dxi-row></dxi-row>
        <dxi-row></dxi-row>
        <dxi-row></dxi-row>
        <dxi-col></dxi-col>
        <dxi-col></dxi-col>

        <dxi-item>
            <dxi-location [row]="0" [col]="0" [colspan]="2"></dxi-location>
            <div class="user-auth-container-input-container">
                <div class="user-auth-container-input-wrapper">
                    <dx-text-box
                        placeholder="Username"
                        [(value)]="forgotPasswordParametersDto.username"
                        (onEnterKey)="btnResetPasswordClick(null)"
                        class="text-input cc-text-required"
                    >
                        <dx-validator>
                            <dxi-validation-rule type="required" message="Username is required"></dxi-validation-rule>
                        </dx-validator>
                    </dx-text-box>
                </div>
            </div>
        </dxi-item>

        <dxi-item>
            <dxi-location [row]="1" [col]="0" [colspan]="2"></dxi-location>
            <div *dxTemplate class="user-auth-container-input-wrapper align-items-center">
                <re-captcha
                    #reCaptcha
                    [siteKey]="recaptchaSiteKey"
                    (resolved)="onRecaptchaResolved($event)"
                ></re-captcha>
            </div>
        </dxi-item>

        <dxi-item>
            <dxi-location [row]="2" [col]="0"></dxi-location>
            <div
                *dxTemplate
                [ngClass]="{
                    'user-auth-container-btn-wrapper': !isSmallScreen,
                    'user-auth-container-btn-wrapper-small': isSmallScreen
                }"
                class="reset-button-wrapper"
            >
                <div class="reset-button-content">
                    <dx-button
                        #btnReset
                        text="Submit"
                        type="default"
                        class="reset-button"
                        [width]="isSmallScreen ? 110 : 130"
                        [height]="30"
                        [disabled]="!recaptchaToken?.length"
                        (onClick)="btnResetPasswordClick($event)"
                    ></dx-button>
                </div>
            </div>
        </dxi-item>

        <dxi-item>
            <dxi-location [row]="2" [col]="1"></dxi-location>
            <div
                *dxTemplate
                [ngClass]="{
                    'user-auth-container-btn-wrapper': !isSmallScreen,
                    'user-auth-container-btn-wrapper-small': isSmallScreen
                }"
                class="align-items-start"
            >
                <dx-button
                    #btnLogin
                    text="Back to Login"
                    type="default"
                    class="login-button"
                    [width]="isSmallScreen ? 110 : 130"
                    [height]="30"
                    (onClick)="btnBackToLogin($event)"
                ></dx-button>
            </div>
        </dxi-item>
    </dx-responsive-box>
</dx-validation-group>

<dx-load-panel
    #loadPanelLogin
    shadingColor="rgba(0,0,0,0.4)"
    [position]="{ of: '#loginContainer' }"
    *ngIf="loadingVisible"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>

<cc-message-box #messageBox></cc-message-box>
